export enum PlaceType {
  fine_dining = 'fine_dining',
  comfort_food = 'comfort_food',
  drinks = 'drinks',
  desserts = 'desserts',
};
